import React, { useState, useEffect } from "react";
import NumberFormat from "react-number-format";
import { Modal, Button } from "antd";
import { Copy, Info, Upload, Gift } from "lucide-react";
import toast from "react-hot-toast";
import TierUpgradeModal from "./wallet/TierUpgradeModal";
import { useNavigate, useLocation } from "react-router-dom";
import { Download } from "lucide-react";

const WalletCard = ({
  tierType,
  displayTitleCheck,
  userTransferData,
  majorPageSpinner,
  walletData,
  onPayBillsClick,
  userData,
  walletBalance,
  fourwardAccount,
  handleTitleCheckChange,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isKonnectBalanceVisible, SetIsKonnectBalanceVisible] = useState(false);
  const [tierUpgradeVisible, setTierUpgradeVisible] = useState(false);
  const [upgradeLoading, setUpgradeLoading] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState("primary");
  const fourwardBalance =
    Number(fourwardAccount?.depositBalance || 0) +
    Number(fourwardAccount?.apvBalance || 0);
  const bonusBalance = Number(
    walletBalance?.bonusBalance ??
    walletBalance?.bonus_bal ??
    walletData?.bonusBalance ??
    0,
  );

  useEffect(() => {
    if (location.state?.openTierModal) {
      setTierUpgradeVisible(true);
      const timer = setTimeout(() => {
        window.history.replaceState({}, document.title);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location.state]);

  const handleUpgradeClick = (e) => {
    e.preventDefault();
    setTierUpgradeVisible(true);
  };

  const handleActivateAccount = (e) => {
    e.preventDefault();
    navigate("/profile/trans-pin");
  };

  const handleTierUpgradeModalClose = () => {
    setTierUpgradeVisible(false);
  };

  const handleUpgrade = async () => {
    try {
      setUpgradeLoading(true);
      navigate("/profile/bvn-verification");
      setTierUpgradeVisible(false);
    } catch (error) {
      toast.error("Failed to initiate upgrade");
    } finally {
      setUpgradeLoading(false);
    }
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="relative py-8 px-10 w-full text-black bg-gray-100 border-2 border-gray-200  flex flex-col gap-y-10 rounded-3xl">
      <div className="flex items-center justify-between">
        <button
          className="py-3 px-8 flex items-center space-x-4 font-gilroyBold rounded-full text-white bg-green-600 hover:bg-green-700 focus:outline-none"
          onClick={SetIsKonnectBalanceVisible}
        >
          Wallet Details
        </button>
        <a
          className="py-3 px-8 flex items-center space-x-4 font-gilroyBold rounded-full text-white bg-black focus:outline-none"
          href="/group-account"
        >
          Group Account
        </a>
        {/* {(userData?.tier === "tier_1" || userData?.tier === "tier_2") && (
          <button
            className="py-3 px-8 flex items-center space-x-4 font-gilroyBold rounded-full text-white bg-black focus:outline-none"
            onClick={onPayBillsClick}
          >
            Pay Bills
          </button>
        )} */}
      </div>

      {displayTitleCheck ? (
        <>
          <div className="flex flex-col gap-y-4">
            <div className="flex items-center justify-between">
              <p className=" text-black font-gil">Wallet Balance</p>
            </div>
            <button className="flex justify-between">
              <div className="flex items-center gap-2 font-gilroyBold">
                <p className="text-4xl ">NGN</p>
                <p className="text-5xl">
                  {!majorPageSpinner ? (
                    <NumberFormat
                      thousandSeparator={true}
                      prefix={""}
                      className="numeric"
                      displayType={"text"}
                      value={Math.floor(
                        walletBalance?.availableBalance,
                      ).toFixed(2)}
                    />
                  ) : (
                    "-"
                  )}
                </p>
              </div>
            </button>

            <div className="w-full bg-black text-white py-3.5 px-5 rounded-2xl shadow-sm flex items-center justify-between border border-gray-900 mt-1">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-xl bg-gray-900 border border-gray-800 flex items-center justify-center text-amber-400 shrink-0">
                  <Gift size={18} />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-semibold text-gray-300 uppercase tracking-wider font-gil">
                      Bonus Balance
                    </span>
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-bold bg-pink-950 text-pink-400 border border-green-800/60">
                      DISCOUNT
                    </span>
                  </div>
                  <p className="text-[11px] text-gray-400 mb-0 font-gil">
                    Applied automatically at checkout
                  </p>
                </div>
              </div>
              <div className="text-right">
                <div className="flex items-center justify-end gap-1 font-gilroyBold">
                  <span className="text-base text-amber-400">₦</span>
                  <span className="text-xl text-white">
                    {!majorPageSpinner ? (
                      <NumberFormat
                        thousandSeparator={true}
                        prefix={""}
                        className="numeric"
                        displayType={"text"}
                        value={bonusBalance.toFixed(2)}
                      />
                    ) : (
                      "0.00"
                    )}
                  </span>
                </div>
              </div>
            </div>

            <Modal
              title={
                <div className="flex items-center gap-2">
                  <Info className="text-blue-500" size={20} />
                  <span>My Wallet Information</span>
                </div>
              }
              centered={true}
              open={isKonnectBalanceVisible}
              onCancel={() => {
                SetIsKonnectBalanceVisible(false);
              }}
              footer={false}
              width={500}
            >
              <div className="py-6">
                <div className="space-y-4">
                  {/* Account ID - Special styling with copy functionality */}
                  <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-4 rounded-lg border border-blue-200">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                        <span className="font-semibold text-gray-700">
                          Account ID
                        </span>
                      </div>
                      <div
                        className="flex items-center gap-2 px-3 py-1 bg-white rounded-md border border-gray-300 cursor-pointer hover:bg-gray-50 transition-colors"
                        onClick={async () => {
                          if (userData.accountId) {
                            await navigator.clipboard.writeText(
                              userData.accountId,
                            );
                            toast.success("Account ID copied to clipboard!");
                          }
                        }}
                        title="Click to copy"
                      >
                        <span className="font-mono text-gray-800">
                          {userData.accountId}
                        </span>
                        <Copy
                          size={14}
                          className="text-blue-500 hover:text-blue-600"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Personal Information Cards */}
                  <div className="grid grid-cols-1 gap-3">
                    <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                          <span className="font-medium text-gray-600">
                            First Name
                          </span>
                        </div>
                        <span className="font-semibold text-gray-800">
                          {userData.firstName}
                        </span>
                      </div>
                    </div>

                    <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                          <span className="font-medium text-gray-600">
                            Last Name
                          </span>
                        </div>
                        <span className="font-semibold text-gray-800">
                          {userData.lastName}
                        </span>
                      </div>
                    </div>

                    <div className="bg-white p-4 rounded-lg border border-gray-200 shadow-sm">
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-amber-500 rounded-full"></div>
                          <span className="font-medium text-gray-600">
                            Tier Type
                          </span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <span
                            className={`px-2 py-1 rounded-full font-semibold ${userData.tier === "tier_0"
                                ? "bg-gray-100 text-gray-800"
                                : userData.tier === "tier_1"
                                  ? "bg-blue-100 text-blue-800"
                                  : userData.tier === "tier_2"
                                    ? "bg-green-100 text-green-800"
                                    : "bg-purple-100 text-purple-800"
                              }`}
                          >
                            {
                              {
                                tier_0: "TIER 0",
                                tier_1: "TIER 1",
                                tier_2: "TIER 2",
                                tier_3: "TIER 3",
                              }[userData.tier]
                            }
                          </span>

                          {tierType === "1" && (
                            <button
                              className="font-gilroyBold text-blue-500 hover:text-blue-700"
                              onClick={handleUpgradeClick}
                            >
                              Upgrade to Tier 2
                            </button>
                          )}
                          {!userData.tier && (
                            <button
                              className="font-gilroyBold text-blue-500"
                              onClick={handleActivateAccount}
                            >
                              Activate Account
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer note */}
                  <div className="mt-6 p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <p className="text-gray-500 text-center">
                      This information is used for transaction verification and
                      account management.
                    </p>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
          <div className="flex  w-full items-center gap-4">
            <div className="py-2 px-5 rounded-xl flex flex-col w-1/2 bg-white focus:outline-none">
              <p className="font-gil text-gray-500">4Ward Balance</p>
              <div className="flex flex-wrap font-bold items-center gap-2 font-gilroyBold">
                <p className="text-xl ">₦</p>
                <p className="text-xl ">
                  {fourwardBalance ? (
                    <NumberFormat
                      thousandSeparator={true}
                      prefix={""}
                      className="numeric"
                      displayType={"text"}
                      value={fourwardBalance.toFixed(2)}
                    />
                  ) : (
                    "0.00"
                  )}
                </p>
              </div>
            </div>
            <div className="py-2 px-5 rounded-xl flex flex-col w-1/2 bg-white focus:outline-none">
              <p className="font-gil text-gray-500">Lien Balance</p>
              <div className="flex flex-wrap font-bold items-center gap-2 font-gilroyBold">
                <p className="text-xl ">₦</p>
                <p className="text-xl ">
                  {/* 9000 */}
                  {!majorPageSpinner ? (
                    <NumberFormat
                      thousandSeparator={true}
                      prefix={""}
                      className="numeric"
                      displayType={"text"}
                      value={Math.floor(+walletBalance?.lien_bal).toFixed(2)}
                    />
                  ) : (
                    "0.00"
                  )}
                </p>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="flex flex-col gap-y-4">
            <div className="flex items-center justify-between">
              <p className="text-black font-gil">
                {selectedAccount === "nuban"
                  ? "NUBAN Account Number"
                  : "Account Number"}
              </p>
            </div>
            <div>
              <h3 className="text-5xl text-black font-medium font-gil">
                {selectedAccount === "nuban"
                  ? userData?.nubanAccount?.accountNumber || "-"
                  : userTransferData.account_number || "-"}
              </h3>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="py-2 px-5 rounded-xl flex flex-col gap-y-2 text-black bg-slate-50 focus:outline-none">
              <p className="text-black font-gilroyBold text-[13px] ">
                Account Name
              </p>
              <h5 className="text-black uppercase font-gilroyBold text-[10px]">
                {selectedAccount === "nuban"
                  ? userData?.nubanAccount?.accountName || "-"
                  : userTransferData.account_name || "-"}
              </h5>
            </div>
            <div className="py-2 px-5 rounded-xl flex flex-col gap-y-2 text-black bg-slate-50 focus:outline-none">
              <p className="text-black font-gilroyBold text-[13px]">
                Bank Name
              </p>
              <h5 className="text-black uppercase font-gilroyBold text-[10px]">
                {selectedAccount === "nuban"
                  ? userData?.nubanAccount?.bankName || "-"
                  : userTransferData.bank_name || "-"}
              </h5>
            </div>
          </div>
        </>
      )}

      <TierUpgradeModal
        visible={tierUpgradeVisible}
        onCancel={handleTierUpgradeModalClose}
        onUpgrade={handleUpgrade}
        walletBalance={walletBalance?.balance || 0}
        loading={upgradeLoading}
      />

      <Modal
        title="Upgrade Notification"
        open={isModalVisible}
        onOk={handleModalClose}
        onCancel={handleModalClose}
        footer={null}
      >
        <p>We will advise you in a few days when you can upgrade to Tier 2.</p>
      </Modal>
    </div>
  );
};

export default WalletCard;
